import type { ExpressionSpecification } from 'mapbox-gl'

/** simplestyle-spec property names, the de facto GeoJSON styling convention. */
export enum TilesetFeatureColorProperty {
  Stroke = 'stroke',
  Fill = 'fill',
  MarkerColor = 'marker-color',
}

/** Builds a Mapbox color expression that preserves the legacy fallback color. */
export function buildTilesetFeatureColor(
  property: TilesetFeatureColorProperty,
  fallbackColor: string,
): ExpressionSpecification {
  return ['to-color', ['get', property], fallbackColor]
}
